/**
 * Initiate accordion for single product pages
 */

const accordion = document.querySelector('.single-product .accordion');

if (accordion) {
	TenUp.accordion({
		target: '.accordion'
	});
}
